import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoriesSection from './components/CategoriesSection';
import WhyOopbuy from './components/WhyOopbuy';
import TrendingProducts from './components/TrendingProducts';
import ReviewsSection from './components/ReviewsSection';
import SeoGuidesSection from './components/SeoGuidesSection';
import CTASection from './components/CTASection';
import FooterSection from './components/FooterSection';
import SEOTextSection from './components/SEOTextSection';

const organizationJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Oopbuy Spreadsheet',
  url: 'https://oopbuyspread.living/',
  logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/5133451b25e408e4a25e4df97e05add8.jpeg',
  description: 'Oopbuy Spreadsheet ist die umfassende Plattform für deutsche Käufer. Entdecken Sie über 1000 Produkte, QC-Services und Express-Lieferung nach Deutschland.',
  foundingDate: '2024',
  areaServed: {
    '@type': 'Country',
    name: 'Deutschland',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer service',
    availableLanguage: ['German', 'English'],
  },
  sameAs: [
    'https://kaspreadsheet.com',
  ],
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationJsonLd) }} />
      <Navbar />
      <main>
        <Hero />
        <CategoriesSection />
        <WhyOopbuy />
        <TrendingProducts />
        <ReviewsSection />
        <SeoGuidesSection />
        <SEOTextSection />
        <CTASection />
      </main>
      <FooterSection />
    </>
  );
}